import { RouteConfig } from 'vue-router';
const List = () => import('./views/list.vue');
const List2 = () => import('./views/list2.vue');
const routers: RouteConfig[] = [
    {
        path: 'list',
        component: List,
    },
    {
        path: 'list2',
        component: List2,
    },
    {
        path: '*',
        redirect: 'list'
    },
];
export default routers;

